export default {
  flags: null,
  dadosRetorno: {
    sucesso: false,
    mensagem: '',
    listaDeErros: {}
  },
  flagsDeControle: {
    carregandoDados: {
      status: false,
      mensagem: ''
    },
    manipulandoDados: {
      status: false,
      mensagem: ''
    }
  }
}
